import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import { userLimits } from '../uitls/userLimits';
import { MenuItem, Select, Box, Typography, Chip, alpha, Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { TextField, Button, Grid, FormLabel } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DescriptionIcon from '@mui/icons-material/Description';
import BuildIcon from '@mui/icons-material/Build';
import AddIcon from '@mui/icons-material/Add';

export default function ViewMagexInvoice(props) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  const dbaUser = user.dba;

  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
    watch,
  } = useForm({});
  let history = useHistory();
  const [data, setData] = useState([]);
  const [reflesh, setReflesh] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [select, setSelect] = useState(null);
  const [rowdata, setrowdata] = useState(null);

  const defaultValues = {
    service: '',
    description: '',
    unit_price: '',
  };

  useEffect(() => {
    const initializeForm = async () => {
      reset(defaultValues);
    };
    initializeForm();
  }, [data]);

  const onSubmit = async (formData) => {
    if (rowdata) {
      request({
        method: 'post',
        url: `/magex/editInvoiceField/` + rowdata._id,
        data: {
          service: formData.service,
          description: formData.description,
          unit_price: formData.unit_price,
        },
      })
        .then(() => {
          Swal.fire({
            title: 'Success',
            text: 'Field has been successfully updated',
            timer: 2000,
          });
          setshow(false);
          setReflesh(!reflesh);
        })
        .catch((error) => {
          Swal.fire({
            title: 'Error',
            text: 'Error to update the field',
            timer: 2000,
          });
        });
    } else {
      request({
        method: 'post',
        url: `/magex/createInvoiceField`,
        data: {
          service: formData.service,
          description: formData.description,
          unit_price: formData.unit_price,
        },
      })
        .then(() => {
          Swal.fire({
            title: 'Success',
            text: 'Field has been successfully created',
            timer: 2000,
          });
          setshow(false);
          setReflesh(!reflesh);
        })
        .catch((error) => {
          Swal.fire({
            title: 'Error',
            text: 'Error to create the field',
            timer: 2000,
          });
        });
    }
  };

  const access = user?.role === 'SuperAdmin' || (user?.role === 'MagexAdmin' && user?.fullAccess);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'get',
        url: `/magex/getAllInvoiceFields`,
      }).then((res) => {
        if (!isCancelled) {
          // console.log('res.data', res.data);
          setData(res.data);
          setIsLoading(true);
        }
      });
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteUser = async (id, referTo) => {
    await request({
      method: 'delete',
      url: `magex/deleteInvoiceField/` + id,
    }).then(() => {
      Swal.fire({
        text: `The Field has been successfully deleted`,
        icon: 'success',
      });
      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const add = () => {
    reset(defaultValues);
    setrowdata(null);
  };

  const columns = [
    {
      title: 'Service',
      field: 'service',
      render: (rowData) => (
        <Chip
          label={rowData.service}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.description}
        </Typography>
      ),
    },
    {
      title: 'Unit Price',
      field: 'unit_price',
      type: 'numeric',
      render: (rowData) => (
        <Chip
          label={rowData.unit_price?.toFixed(2) || '0.00'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
  ];

  return (
    <ModernPageContainer>
      {!isloading && <LoadingIcon />}

      <ModernPageHeader
        title="Magex Invoice Fields"
        subtitle="Manage invoice field templates"
        icon={ReceiptIcon}
      />

      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Add Invoice Field
              </Typography>
            </Grid>
              <Grid item xs={3}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Serivce"
                  InputLabelProps={{ shrink: true }}
                  name="service"
                  inputProps={{
                    maxLength: '100',
                  }}
                  {...register('service', {})}
                />
                {errors.service && <p className="signUpErrorMessage">{errors.service.message}</p>}
              </Grid>
              <Grid item xs={8}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Description"
                  name="description"
                  InputLabelProps={{ shrink: true }}
                  multiline
                  {...register('description', {})}
                />
                {errors.description && (
                  <p className="signUpErrorMessage">{errors.description.message}</p>
                )}
              </Grid>
              <Grid item xs={1}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Unit Price"
                  name="unit_price"
                  type="number"
                  disabled={rowdata?.service === 'License Fee'}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    maxLength: '100',
                  }}
                  {...register('unit_price', {})}
                />
                {errors.unit_price && (
                  <p className="signUpErrorMessage">{errors.unit_price.message}</p>
                )}
              </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                {rowdata && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={add}
                    startIcon={<AddIcon />}
                    sx={{ height: '40px' }}
                  >
                    Add New
                  </Button>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ height: '40px' }}
                >
                  Submit
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Box sx={{ mt: 3 }}>
        <ModernTable
            columns={columns}
            data={data}
            title={'Magex Invoice'}
            options={{
              paging: true,
              pageSize: 10,
              pageSizeOptions: [10, 20, 50],
            }}
            localization={{ body: { editRow: { deleteText: 'Are you sure to delete this user' } } }}
            actions={[
              {
                icon: 'edit',
                tooltip: 'Edit Info',
                onClick: (event, rowdata) => {
                  reset({
                    service: rowdata.service,
                    description: rowdata.description,
                    unit_price: rowdata.unit_price,
                  });
                  setrowdata(rowdata);
                },
              },
            ]}
            editable={
              !access
                ? {}
                : {
                    onRowDelete: (oldData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          deleteUser(oldData._id);
                          resolve();
                        }, 600);
                      }),
                  }
            }
          />
      </Box>
    </ModernPageContainer>
  );
}
